module.exports = __webpack_public_path__ + "img/7ne.90c86b69.svg";